module.exports = __webpack_public_path__ + "img/background051.jpg";